import styles from "./AssessmentBy.module.scss";

export const AssessmentBy = () => {
    return (
        <div className={styles.assessmentBy}>
            <div className={styles.title}>
                PSYCHOPHYSICAL CONSTITUTION ASSESSMENT
            </div>
            <div className={styles.text}>
                Conducted personally by Dr. Torsunov
                <br /> + individual consultation with his students
            </div>
        </div>
    );
};
